import { FaTimes, FaCloudUploadAlt, FaTrash, FaEye } from "react-icons/fa";
import { useEffect, useState, useRef } from "react";
import pathconfig from '../../pathconfig.json';
import axios from 'axios';
import moment from 'moment';
import { MdDownload } from "react-icons/md";
import { toastError, toastSuccess } from '../toaster';
import NodataFound from "../nodata";
import packjson from '../../../package.json';
import { useAppContextProvider } from '../../contextapi';

const VideoTab = (props) => {
    const [fileData, setFileData] = useState([]);
    const [fileUpdate, setFileUpdate] = useState([]);
    const fileInputRef = useRef(null);
    const { userProfile, setSidebarClose, videoGetData } = useAppContextProvider();
    const [deleteData, setDeleteData] = useState('');
    const [showconfirm, setConfirm] = useState(false);
    const [showVideoModal, setShowVideoModal] = useState(false);
    const [showImageModal, setShowImageModal] = useState(false);
    const [showAudioModal, setShowAudioModal] = useState(false);
    const [currentVideo, setCurrentVideo] = useState(null);
    const [currentImage, setCurrentImage] = useState(null);
    const [currentAudio, setCurrentAudio] = useState(null);
    const [availableSubtitles, setAvailableSubtitles] = useState([]);
    const [selectedSubtitle, setSelectedSubtitle] = useState(null);
    const [subtitleTracks, setSubtitleTracks] = useState([]);
    const [isDownloading, setIsDownloading] = useState(false);
    const [isVideoLoading, setIsVideoLoading] = useState(false);
    const [isImageLoading, setIsImageLoading] = useState(false);
    const [isAudioLoading, setIsAudioLoading] = useState(false);
    const [loadingItemId, setLoadingItemId] = useState(null);
    const videoRef = useRef(null);
    const audioRef = useRef(null);
    const closeBtnRef = useRef(null);

    // CSS Loader Component
    const CSSLoader = () => (
        <span className="cssLoader"></span>
    );

    // Small CSS Loader for buttons
    const SmallCSSLoader = () => (
        <div style={{
            width: '12px',
            height: '12px',
            border: '2px solid rgba(63, 82, 163, 0.3)',
            borderTop: '2px solid #3f52a3',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            display: 'inline-block'
        }}>
            <style jsx>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );

    useEffect(() => {
        if (videoGetData) {
            setFileUpdate(videoGetData);
        }
        getFiles(userProfile.docid);
    }, [videoGetData, userProfile.docid]);

    useEffect(() => {
        if (closeBtnRef.current) {
            closeBtnRef.current.focus();
        }
    }, [props.leftsidebarvalue])

    // Add ESC key listener
    useEffect(() => {
        const handleEscKey = (event) => {
            if (event.key === 'Escape') {
                if (showVideoModal) {
                    closeVideoModal();
                } else if (showImageModal) {
                    closeImageModal();
                } else if (showAudioModal) {
                    closeAudioModal();
                }
            }
        };

        document.addEventListener('keydown', handleEscKey);
        return () => {
            document.removeEventListener('keydown', handleEscKey);
        };
    }, [showVideoModal, showImageModal, showAudioModal]);

    // Add global CSS for animations
    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
            @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
        `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };
    }, []);

    const getFiles = (value) => {
        let url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].retrievefiles}`;
        let GetDetailDataString = localStorage.getItem(`${value}_init-getdetails`);
        let GetDetailData = JSON.parse(GetDetailDataString);
         var data = {
            InputPath: `${GetDetailData.Articledetails.ArtResourcePath}/Supplementary/Video`,
        }
        axios.post(url, data)
            .then((response) => {
                setFileData(response.data);
                console.log(response.data, 'response.data')
            }).catch((error) => {
                console.log(error)
                toastError(error.message);
            })
    }

    // Check if file is a video
    const isVideoFile = (filename) => {
        const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv', 'm4v', '3gp', 'ogv'];
        const extension = filename.split('.').pop().toLowerCase();
        return videoExtensions.includes(extension);
    };

    // Check if file is an audio
    const isAudioFile = (filename) => {
        const audioExtensions = ['mp3', 'wav', 'ogg', 'aac', 'flac', 'm4a', 'wma'];
        const extension = filename.split('.').pop().toLowerCase();
        return audioExtensions.includes(extension);
    };

    // Check if file is an image
    const isImageFile = (filename) => {
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'tiff', 'ico'];
        const extension = filename.split('.').pop().toLowerCase();
        return imageExtensions.includes(extension);
    };

    // Check if file is a subtitle file
    const isSubtitleFile = (filename) => {
        const subtitleExtensions = ['srt', 'vtt', 'ass', 'ssa', 'sub', 'sbv', 'cc', 'ttml'];
        const extension = filename.split('.').pop().toLowerCase();
        return subtitleExtensions.includes(extension);
    };

    // Check if file should show download icon (not video, audio, or image)
    const shouldShowDownloadIcon = (filename) => {
        // return !isVideoFile(filename) && !isAudioFile(filename) && !isImageFile(filename) && !isSubtitleFile(filename);
        return true;
    };

    // Find the paired .ttml file for a given video filename (e.g. mmc04-01-xxx.mp4 → mmc04-01-xxx.ttml)
    const findTtmlForVideo = (videoFilename) => {
        const videoBaseName = videoFilename.substring(0, videoFilename.lastIndexOf('.'));
        return fileData.find(file => {
            const fname = file.path.split('/').pop();
            const ext = fname.split('.').pop().toLowerCase();
            const base = fname.substring(0, fname.lastIndexOf('.'));
            return ext === 'ttml' && base === videoBaseName;
        }) || null;
    };

    // Find all subtitle files for a video
    const findSubtitlesForVideo = (videoFilename) => {
        const videoBaseName = videoFilename.substring(0, videoFilename.lastIndexOf('.'));
        const subtitleFiles = fileData.filter(file => {
            const filename = file.path.split('/').pop();
            const fileBaseName = filename.substring(0, filename.lastIndexOf('.'));
            return isSubtitleFile(filename) && fileBaseName.startsWith(videoBaseName);
        }).sort((a, b) => {
            const extA = a.path.split('.').pop().toLowerCase();
            const extB = b.path.split('.').pop().toLowerCase();
            const order = ['ttml', 'vtt', 'srt', 'ass', 'ssa', 'sub', 'sbv', 'cc'];
            const indexA = order.indexOf(extA);
            const indexB = order.indexOf(extB);
            return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
        });
        return subtitleFiles;
    };

    // Get file blob URL with proper MIME type - Fixed to prevent multiple calls
    const getFileBlobUrl = async (path, mimeType) => {
        try {
            let urlPath = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].download}`;
            const response = await axios.post(urlPath, {
                blobUrl: path,
                type: mimeType
            }, {
                responseType: 'blob',
            });
            return window.URL.createObjectURL(new Blob([response.data], { type: mimeType }));
        } catch (error) {
            console.error('Error getting file blob:', error);
            toastError('Failed to load file');
            return null;
        }
    };

    // Get subtitle content
    const getSubtitleContent = async (path) => {
        try {
            let urlPath = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].download}`;
            const response = await axios.post(urlPath, {
                blobUrl: path,
                type: 'text/plain'
            }, {
                responseType: 'text',
            });
            return response.data;
        } catch (error) {
            console.error('Error getting subtitle:', error);
            return '';
        }
    };

    // Convert SRT to VTT format if needed
    const convertSrtToVtt = (srtContent) => {
        if (srtContent.startsWith('WEBVTT')) {
            return srtContent;
        }

        let vttContent = 'WEBVTT\n\n';
        vttContent += srtContent.replace(/(\d{2}):(\d{2}):(\d{2}),(\d{3})/g, '$1:$2:$3.$4');
        return vttContent;
    };

    // Convert TTML to VTT format
    const convertTtmlToVtt = (ttmlContent) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(ttmlContent, 'text/xml');
        const cues = xmlDoc.getElementsByTagName('p');

        const frameRate = 30;

        const convertTime = (time) => {
            // format HH:MM:SS:FF
            const parts = time.split(':');
            if (parts.length !== 4) return time;

            const [hh, mm, ss, ff] = parts.map(Number);
            const ms = Math.round((ff / frameRate) * 1000);

            const msStr = ms.toString().padStart(3, '0');

            return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}:${String(ss).padStart(2, '0')}.${msStr}`;
        };

        let vtt = 'WEBVTT\n\n';

        for (let cue of cues) {
            const begin = cue.getAttribute('begin');
            const end = cue.getAttribute('end');

            let text = cue.innerHTML
                .replace(/<br\s*\/?>/gi, '\n')
                .replace(/<[^>]+>/g, '')
                .trim();

            if (begin && end && text) {
                const start = convertTime(begin);
                const stop = convertTime(end);

                vtt += `${start} --> ${stop}\n${text}\n\n`;
            }
        }

        return vtt;
    };

    // Get MIME type for video
    const getVideoMimeType = (filename) => {
        const extension = filename.split('.').pop().toLowerCase();
        const mimeTypes = {
            'mp4': 'video/mp4',
            'avi': 'video/x-msvideo',
            'mov': 'video/quicktime',
            'wmv': 'video/x-ms-wmv',
            'flv': 'video/x-flv',
            'webm': 'video/webm',
            'mkv': 'video/x-matroska',
            'm4v': 'video/x-m4v',
            '3gp': 'video/3gpp',
            'ogv': 'video/ogg'
        };
        return mimeTypes[extension] || 'video/mp4';
    };

    // Get MIME type for audio
    const getAudioMimeType = (filename) => {
        const extension = filename.split('.').pop().toLowerCase();
        const mimeTypes = {
            'mp3': 'audio/mpeg',
            'wav': 'audio/wav',
            'ogg': 'audio/ogg',
            'aac': 'audio/aac',
            'flac': 'audio/flac',
            'm4a': 'audio/mp4',
            'wma': 'audio/x-ms-wma'
        };
        return mimeTypes[extension] || 'audio/mpeg';
    };

    // Get MIME type for image
    const getImageMimeType = (filename) => {
        const extension = filename.split('.').pop().toLowerCase();
        const mimeTypes = {
            'jpg': 'image/jpeg',
            'jpeg': 'image/jpeg',
            'png': 'image/png',
            'gif': 'image/gif',
            'bmp': 'image/bmp',
            'svg': 'image/svg+xml',
            'webp': 'image/webp',
            'tiff': 'image/tiff',
            'ico': 'image/x-icon'
        };
        return mimeTypes[extension] || 'image/jpeg';
    };

    // Play video with subtitle selection - Fixed to prevent multiple API calls
    const playVideo = async (videoItem) => {
        // Prevent multiple calls if already loading
        if (isVideoLoading || loadingItemId === videoItem.path) {
            return;
        }

        setIsVideoLoading(true);
        setLoadingItemId(videoItem.path);

        try {
            const filename = videoItem.path.split('/').pop();
            const mimeType = getVideoMimeType(filename);
            const videoUrl = await getFileBlobUrl(videoItem.path, mimeType);
            if (!videoUrl) {
                setIsVideoLoading(false);
                setLoadingItemId(null);
                return;
            }

            const subtitleFiles = findSubtitlesForVideo(filename);
            const subtitleTracks = [];

            // Process subtitles sequentially to avoid multiple API calls
            for (const subtitleFile of subtitleFiles) {
                const subtitleContent = await getSubtitleContent(subtitleFile.path);
                const filename = subtitleFile.path.split('/').pop();
                const extension = filename.split('.').pop().toLowerCase();
                let vttContent;
                if (extension === 'ttml') {
                    vttContent = convertTtmlToVtt(subtitleContent);
                } else if (extension === 'srt') {
                    vttContent = convertSrtToVtt(subtitleContent);
                } else {
                    vttContent = subtitleContent; // assume VTT or other supported format
                }
                const subtitleBlob = new Blob([vttContent], { type: 'text/vtt' });
                const subtitleUrl = window.URL.createObjectURL(subtitleBlob);

                subtitleTracks.push({
                    kind: 'subtitles',
                    src: subtitleUrl,
                    srcLang: 'en',
                    label: filename,
                    default: subtitleTracks.length === 0
                });
            }

            setCurrentVideo({
                ...videoItem,
                url: videoUrl,
                filename: filename
            });
            setAvailableSubtitles(subtitleFiles);
            setSubtitleTracks(subtitleTracks);

            if (subtitleTracks.length > 0) {
                setSelectedSubtitle(subtitleTracks[0]);
            } else {
                setSelectedSubtitle(null);
            }

            setShowVideoModal(true);
        } catch (error) {
            console.error('Error playing video:', error);
            toastError('Failed to load video');
        } finally {
            setIsVideoLoading(false);
            setLoadingItemId(null);
        }
    };

    // Play audio - New function for audio files
    const playAudio = async (audioItem) => {
        // Prevent multiple calls if already loading
        if (isAudioLoading || loadingItemId === audioItem.path) {
            return;
        }

        setIsAudioLoading(true);
        setLoadingItemId(audioItem.path);

        try {
            const filename = audioItem.path.split('/').pop();
            const mimeType = getAudioMimeType(filename);
            const audioUrl = await getFileBlobUrl(audioItem.path, mimeType);
            if (!audioUrl) {
                setIsAudioLoading(false);
                setLoadingItemId(null);
                return;
            }

            setCurrentAudio({
                ...audioItem,
                url: audioUrl,
                filename: filename
            });

            setShowAudioModal(true);
        } catch (error) {
            console.error('Error playing audio:', error);
            toastError('Failed to load audio');
        } finally {
            setIsAudioLoading(false);
            setLoadingItemId(null);
        }
    };

    // View image - Fixed to prevent multiple API calls
    const viewImage = async (imageItem) => {
        // Prevent multiple calls if already loading
        if (isImageLoading || loadingItemId === imageItem.path) {
            return;
        }

        setIsImageLoading(true);
        setLoadingItemId(imageItem.path);

        try {
            const filename = imageItem.path.split('/').pop();
            const mimeType = getImageMimeType(filename);
            const imageUrl = await getFileBlobUrl(imageItem.path, mimeType);
            if (!imageUrl) {
                setIsImageLoading(false);
                setLoadingItemId(null);
                return;
            }

            setCurrentImage({
                ...imageItem,
                url: imageUrl,
                filename: filename
            });
            setShowImageModal(true);
        } catch (error) {
            console.error('Error viewing image:', error);
            toastError('Failed to load image');
        } finally {
            setIsImageLoading(false);
            setLoadingItemId(null);
        }
    };

    // Close video modal
    const closeVideoModal = () => {
        setShowVideoModal(false);
        if (currentVideo?.url) {
            window.URL.revokeObjectURL(currentVideo.url);
        }
        // Clean up subtitle URLs
        subtitleTracks.forEach(track => {
            if (track.src) {
                window.URL.revokeObjectURL(track.src);
            }
        });
        setCurrentVideo(null);
        setAvailableSubtitles([]);
        setSubtitleTracks([]);
        setSelectedSubtitle(null);
    };

    // Close audio modal
    const closeAudioModal = () => {
        setShowAudioModal(false);
        if (currentAudio?.url) {
            window.URL.revokeObjectURL(currentAudio.url);
        }
        setCurrentAudio(null);
    };

    // Close image modal
    const closeImageModal = () => {
        setShowImageModal(false);
        if (currentImage?.url) {
            window.URL.revokeObjectURL(currentImage.url);
        }
        setCurrentImage(null);
    };

    // Handle subtitle selection change
    const handleSubtitleChange = (event) => {
        const selectedIndex = event.target.value;
        if (selectedIndex === 'none') {
            setSelectedSubtitle(null);
            if (videoRef.current) {
                const tracks = videoRef.current.textTracks;
                for (let i = 0; i < tracks.length; i++) {
                    tracks[i].mode = 'disabled';
                }
            }
        } else {
            setSelectedSubtitle(subtitleTracks[selectedIndex]);
            if (videoRef.current) {
                const tracks = videoRef.current.textTracks;
                for (let i = 0; i < tracks.length; i++) {
                    tracks[i].mode = i === parseInt(selectedIndex) ? 'showing' : 'disabled';
                }
            }
        }
    };

    const fileDownload = async (fileType, path, skipLoading = false) => {
        if (!skipLoading && isDownloading) {
            toastError('Download already in progress. Please wait.');
            return;
        }

        if (!skipLoading) setIsDownloading(true);

        try {
            let fileExtension = fileType.split('.').pop().toLowerCase();
            let mimeType;
            if (fileExtension === 'doc') {
                mimeType = 'application/msword';
            } else if (fileExtension === 'docx') {
                mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            } else if (fileExtension === 'xls') {
                mimeType = 'application/vnd.ms-excel';
            } else if (fileExtension === 'xlsx') {
                mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            } else if (fileExtension === 'ppt') {
                mimeType = 'vnd.ms-powerpoint';
            } else if (fileExtension === 'pptx') {
                mimeType = 'vnd.openxmlformats-officedocument.presentationml.presentation';
            } else if (fileExtension === '7z') {
                mimeType = 'x-7z-compressed';
            } else if (fileExtension === 'swf') {
                mimeType = 'x-shockwave-flash';
            } else {
                mimeType = `application/${fileExtension}`;
            }
            let urlPath = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].download}`;

            const response = await axios.post(urlPath, {
                blobUrl: path,
                type: mimeType
            }, {
                responseType: 'blob',
            });
            const url = window.URL.createObjectURL(new Blob([response.data], { type: mimeType }));
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = `${fileType}`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            if (!skipLoading) toastSuccess(`Video file has been successfully downloaded.`);

            // Auto-download the paired .ttml file whenever a video file is downloaded
            if (!skipLoading && isVideoFile(fileType)) {
                const ttmlFile = findTtmlForVideo(fileType);
                if (ttmlFile) {
                    const ttmlFilename = ttmlFile.path.split('/').pop();
                    console.log(`[Video] Auto-downloading paired TTML: ${ttmlFilename}`);
                    await fileDownload(ttmlFilename, ttmlFile.path, true /* skipLoading */);
                    toastSuccess(`Paired subtitle file (${ttmlFilename}) has also been downloaded.`);
                } else {
                    console.log(`[Video] No paired .ttml found for: ${fileType}`);
                }
            }
        } catch (error) {
            console.error('Download error:', error);
            if (!skipLoading) toastError('Failed to download file.');
        } finally {
            if (!skipLoading) setIsDownloading(false);
        }
    }

    // Modal download function for video/image/audio files
    const modalFileDownload = async (item) => {
        const filename = item.path.split('/').pop();
        await fileDownload(filename, item.path);
    };

    const handleFileupload = (e) => {
        try {
            let docId = userProfile.docid;
            const uploadedFile = e.target.files[0];
            const maxSize = 40 * 1024 * 1024;

            if (uploadedFile.size > maxSize) {
                toastError('File size exceeds maximum limit of 40MB');
                return;
            }
            let GetDetailDataString = localStorage.getItem(`${docId}_init-getdetails`);
            let GetDetailData = JSON.parse(GetDetailDataString);
            var formdata = new FormData();

            if (!GetDetailDataString) {
                toastError('Document details not found');
                return;
            }
            let fileName = e.target.files[0];
            formdata.append("files", e.target.files[0]);
            formdata.append("path", `${GetDetailData.Articledetails.ArtResourcePath}/Supplementary/Video`);
            formdata.append("role", userProfile.role);
            formdata.append("username", userProfile.username)
            const url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].supplymentAttachment}`;
            axios.post(url, formdata, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }).then((response) => {
                if (response.data.success) {
                    toastSuccess(response.data.message);
                    getFiles(docId);
                }
            }).catch(error => {
                // Show the backend rejection message (e.g. restricted file format)
                toastError(error.response?.data?.error || 'Failed to upload a file.');
            });
            } catch (error) {
            toastError('Error processing file upload');
            console.error('File upload error:', error);
        } finally {
            e.target.value = null;
        }
    }

    const deleteConfirm = (value) => {
        setDeleteData(value)
        setConfirm(true)
    }

    const deleteAttchment = () => {
        let dataValue = deleteData;
        let data = {
            "filePath": dataValue.path,
        }
        const deleteUrl = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].deleteBlobFile}`
        axios.post(deleteUrl, data).then((response) => {
            setConfirm(false)
            toastSuccess(`${response.data.message}`);
            getFiles(userProfile.docid)
        }
        ).catch((error) => {
            console.log(error);
            toastError(error.message);
        })
    }

    return (
        <div className="video-area">
            <header className="slider-header">
                <h2>Video files</h2>
                <div>
                    <button
                        className="close-btn"
                        title="Close"
                        ref={closeBtnRef}
                        tabIndex={0}
                        onClick={() => {
                            setSidebarClose(true);
                            setTimeout(() => {
                                const suppBtn = document.getElementById('video-tab-btn');
                                if (suppBtn) suppBtn.focus();
                            }, 0);
                        }}
                        onKeyDown={e => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                setSidebarClose(true);
                                setTimeout(() => {
                                    const suppBtn = document.getElementById('video-tab-btn');
                                    if (suppBtn) suppBtn.focus();
                                }, 0);
                            }
                        }}
                    >
                        <FaTimes />
                    </button>
                </div>
            </header>

            {/* Loading Overlay with CSS Loader */}
            {(isVideoLoading || isImageLoading || isAudioLoading) && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9998,
                    backdropFilter: 'blur(5px)'
                }}>
                    <CSSLoader />
                </div>
            )}

            {/* Video Player Modal with blur background */}
            <div className={`modal-outer ${showVideoModal ? "active" : ""}`} style={{
                backgroundColor: showVideoModal ? 'rgba(0, 0, 0, 0.8)' : 'transparent',
                backdropFilter: showVideoModal ? 'blur(5px)' : 'none'
            }}>
                <div className="modal video-modal" style={{
                    maxWidth: '90vw',
                    maxHeight: '90vh',
                    width: 'auto',
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 9999,
                    overflow: 'hidden',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
                }}>
                    <div className="modal-header">
                        <h3>{currentVideo?.filename}</h3>
                        <div className="header-actions">
                            {availableSubtitles.length > 0 && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <label htmlFor="subtitle-select" style={{ whiteSpace: 'nowrap' }}>
                                        Subtitles:
                                    </label>
                                    <select
                                        id="subtitle-select"
                                        value={selectedSubtitle ? subtitleTracks.indexOf(selectedSubtitle) : 'none'}
                                        onChange={handleSubtitleChange}
                                    >
                                        <option value="none">None</option>
                                        {subtitleTracks.map((track, index) => (
                                            <option key={index} value={index}>
                                                {track.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            <button
                                className="modal-download-btn"
                                title="Download Video"
                                onClick={() => modalFileDownload(currentVideo)}
                                disabled={isDownloading}
                            >
                                <MdDownload />
                                {isDownloading ? 'Downloading...' : 'Download'}
                            </button>
                            <button className="modal-close-btn" onClick={closeVideoModal}>
                                <FaTimes />
                            </button>
                        </div>
                    </div>
                    <div className="modal-body" style={{ padding: '0', height: 'calc(90vh - 80px)' }}>
                        {currentVideo && (
                            <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                                <video
                                    ref={videoRef}
                                    controls
                                    autoPlay
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain'
                                    }}
                                    src={currentVideo.url}
                                    // onLoadedMetadata={() => {
                                    //     if (selectedSubtitle && videoRef.current) {
                                    //         const tracks = videoRef.current.textTracks;
                                    //         for (let i = 0; i < tracks.length; i++) {
                                    //             tracks[i].mode = i === 0 ? 'showing' : 'disabled';
                                    //         }
                                    //     }
                                    // }}
                                    onLoadedMetadata={() => {
                                        if (selectedSubtitle && videoRef.current) {
                                            const tracks = videoRef.current.textTracks;
                                            for (let i = 0; i < tracks.length; i++) {
                                                tracks[i].mode = i === 0 ? 'showing' : 'disabled';
                                            }
                                        }
                                    }}
                                >
                                    {subtitleTracks.map((track, index) => (
                                        <track
                                            key={index}
                                            kind="subtitles"
                                            src={track.src}
                                            srcLang={track.srcLang}
                                            label={track.label}
                                            default={index === 0}
                                        />
                                    ))}
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Audio Player Modal with blur background */}
            <div className={`modal-outer ${showAudioModal ? "active" : ""}`} style={{
                backgroundColor: showAudioModal ? 'rgba(0, 0, 0, 0.8)' : 'transparent',
                backdropFilter: showAudioModal ? 'blur(5px)' : 'none'
            }}>
                <div className="modal audio-modal" style={{
                    maxWidth: '600px',
                    width: '90vw',
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 9999,
                    overflow: 'hidden',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
                }}>
                    <div className="modal-header">
                        <h3>{currentAudio?.filename}</h3>
                        <div className="header-actions">
                            <button
                                className="modal-download-btn"
                                title="Download Audio"
                                onClick={() => modalFileDownload(currentAudio)}
                                disabled={isDownloading}
                            >
                                <MdDownload />
                                {isDownloading ? 'Downloading...' : 'Download'}
                            </button>
                            <button className="modal-close-btn" onClick={closeAudioModal}>
                                <FaTimes />
                            </button>
                        </div>
                    </div>
                    <div className="modal-body" style={{ padding: '20px', textAlign: 'center' }}>
                        {currentAudio && (
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '20px'
                            }}>
                                <div style={{
                                    fontSize: '48px',
                                    color: '#3f52a3',
                                    marginBottom: '10px'
                                }}>
                                    🎵
                                </div>
                                <audio
                                    ref={audioRef}
                                    controls
                                    style={{
                                        width: '100%',
                                        maxWidth: '500px'
                                    }}
                                    src={currentAudio.url}
                                >
                                    Your browser does not support the audio tag.
                                </audio>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Image Viewer Modal with blur background */}
            <div className={`modal-outer ${showImageModal ? "active" : ""}`} style={{
                backgroundColor: showImageModal ? 'rgba(0, 0, 0, 0.8)' : 'transparent',
                backdropFilter: showImageModal ? 'blur(5px)' : 'none'
            }}>
                <div className="modal image-modal" style={{
                    maxWidth: '90vw',
                    maxHeight: '90vh',
                    width: 'auto',
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 9999,
                    overflow: 'hidden',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
                }}>
                    <div className="modal-header">
                        <h3>{currentImage?.filename}</h3>
                        <div className="header-actions">
                            <button
                                className="modal-download-btn"
                                title="Download Image"
                                onClick={() => modalFileDownload(currentImage)}
                                disabled={isDownloading}
                            >
                                <MdDownload />
                                {isDownloading ? 'Downloading...' : 'Download'}
                            </button>
                            <button className="modal-close-btn" onClick={closeImageModal}>
                                <FaTimes />
                            </button>
                        </div>
                    </div>
                    <div className="modal-body" style={{ padding: '20px', height: 'calc(90vh - 80px)', overflow: 'auto' }}>
                        {currentImage && (
                            <img
                                src={currentImage.url}
                                alt={currentImage.filename}
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    objectFit: 'contain',
                                    borderRadius: '8px',
                                    display: 'block',
                                    margin: '0 auto'
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>

            {/* Delete Confirmation Modal */}
            <div className={`modal-outer ${showconfirm ? "active" : ""}`}>
                <div className="modal confirmation-popup">
                    <div className="modal-header">
                        <h1>Confirm Delete</h1>
                        <button className="modal-close-btn" onClick={() => setConfirm(false)}><FaTimes /></button>
                    </div>
                    <div className="modal-body">
                        <p style={{ textAlign: 'center', margin: '10px 0' }}>Are you sure you want to delete this file?</p>
                    </div>
                    <div className="modal-footer">
                        <button className="primary" onClick={deleteAttchment}>Yes</button>
                        <button className="outline-secondary" onClick={() => setConfirm(false)}>No</button>
                    </div>
                </div>
            </div>

            <div className="video-list">
                {!["Editor", "Author", "Master Copier"].includes(userProfile.role) ? <div className="upload-btn-wrapper">
                    <FaCloudUploadAlt />
                    <p>Choose file or drag here</p>
                    <input type="file" onChange={(e) => handleFileupload(e)} ref={fileInputRef} />
                </div> : ""}
                {fileData.length !== 0 ? fileData.map((item, index) => {
                    const filename = item.path.split('/').pop();
                    const isVideo = isVideoFile(filename);
                    const isImage = isImageFile(filename);
                    const isAudio = isAudioFile(filename);
                    const isSubtitle = isSubtitleFile(filename);
                    const showDownload = shouldShowDownloadIcon(filename);
                    const isCurrentlyLoading = loadingItemId === item.path;

                    return (
                        <div className="video-list-group" key={index}>
                            <div className="video-action">
                                {/* View button for video files */}
                                {isVideo && (
                                    <button
                                        className="view-btn"
                                        title="View Video"
                                        onClick={() => playVideo(item)}
                                        disabled={isCurrentlyLoading || isVideoLoading}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            cursor: isCurrentlyLoading ? 'not-allowed' : 'pointer',
                                            opacity: isCurrentlyLoading ? 0.6 : 1,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#3f52a3',
                                            fontSize: '16px'
                                        }}
                                    >
                                        {isCurrentlyLoading ? (
                                            <span className="loader"></span>
                                        ) : (
                                            <FaEye />
                                        )}
                                    </button>
                                )}

                                {/* View button for audio files */}
                                {isAudio && (
                                    <button
                                        className="view-btn"
                                        title="View Audio"
                                        onClick={() => playAudio(item)}
                                        disabled={isCurrentlyLoading || isAudioLoading}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            cursor: isCurrentlyLoading ? 'not-allowed' : 'pointer',
                                            opacity: isCurrentlyLoading ? 0.6 : 1,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#3f52a3',
                                            fontSize: '16px'
                                        }}
                                    >
                                        {isCurrentlyLoading ? (
                                            <SmallCSSLoader />
                                        ) : (
                                            <FaEye />
                                        )}
                                    </button>
                                )}

                                {/* View button for images */}
                                {isImage && (
                                    <button
                                        className="view-btn"
                                        title="View Image"
                                        onClick={() => viewImage(item)}
                                        disabled={isCurrentlyLoading || isImageLoading}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            cursor: isCurrentlyLoading ? 'not-allowed' : 'pointer',
                                            // marginRight: '5px',
                                            opacity: isCurrentlyLoading ? 0.6 : 1,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#3f52a3',
                                            fontSize: '16px'
                                        }}
                                    >
                                        {isCurrentlyLoading ? (
                                            <SmallCSSLoader />
                                        ) : (
                                            <FaEye />
                                        )}
                                    </button>
                                )}

                                {/* Download button only for non-media files */}
                                {showDownload && (
                                    <button
                                        className="download-btn"
                                        title="Download"
                                        onClick={() => fileDownload(filename, item.path)}
                                        disabled={isDownloading}
                                        style={{
                                            opacity: isDownloading ? 0.6 : 1,
                                            cursor: isDownloading ? 'not-allowed' : 'pointer',
                                            padding: '0 5px 0 0',
                                            // paddingRight: '5px',
                                        }}
                                    >
                                        <MdDownload />
                                    </button>
                                )}

                                {/* Delete button */}
                                {userProfile?.role === item?.metadata.role && (
                                    <button
                                        className="close-btn"
                                        title="delete"
                                        onClick={() => deleteConfirm(item)}
                                        style={{
                                            // padding: 0,
                                            padding: '0 5px 0 0',
                                        }}
                                    >
                                        <FaTrash />
                                    </button>
                                )}
                            </div>
                            <p title={filename} style={{ width: '65%' }}>
                                {filename}
                                {/* {isVideo && (
                                    <span style={{ color: '#28a745', marginLeft: '5px' }}>🎬</span>
                                )}
                                {isAudio && (
                                    <span style={{ color: '#28a745', marginLeft: '5px' }}>🎵</span>
                                )}
                                {isImage && (
                                    <span style={{ color: '#007bff', marginLeft: '5px' }}>🖼️</span>
                                )}
                                {isSubtitle && (
                                    <span style={{ color: '#6c757d', marginLeft: '5px' }}>📝 CC</span>
                                )} */}
                            </p>
                            <p>role: {item?.metadata.role === undefined ? 'Admin' : item?.metadata.role}</p>
                            <span>Date: {moment(item.createdOn).format("DD-MM-YYYY - HH:mm:ss")}</span>
                        </div>
                    )
                }) : <NodataFound />}
            </div>
        </div>
    )
}
export default VideoTab;